import * as React from "react";
const SvgCube = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m50 37-8-4-8 4m16 0-8 4m8-4v10l-8 4m-8-14 8 4m-8-4v10l8 4m0-10v10"
    />
  </svg>
);
export default SvgCube;
